import cx from 'classnames';
import { fold_line_small_off, fold_line_small_on } from 'components/base/images';
import CircularLoading from 'components/base/loading/CircularLoading';
import CustomText from 'components/common/text/CustomText';
import { OffsetPagingData } from 'lib/types/sharedTypes';
import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import styled from 'styled-components';

interface ProjectInfoHistoryProps {
  isOpen: boolean;
  onClick: () => void;
  projectHistoryList: object | any;
  projectHistoryPagingData: OffsetPagingData;
  page: {
    value: number;
    onChange: (e: any) => void;
    setValue: React.Dispatch<any>;
  };
  isFetchSuccess: boolean;
  historyInfoRef: React.RefObject<HTMLDivElement>;
  onFetchHistoryList: () => void;
  language: string;
  isClinic: boolean;
}

function ProjectInfoHistory({
  isOpen,
  onClick,
  projectHistoryList,
  projectHistoryPagingData,
  page,
  isFetchSuccess,
  historyInfoRef,
  onFetchHistoryList,
  language,
  isClinic,
}: ProjectInfoHistoryProps) {
  const { t } = useTranslation();
  const hasMoreHistoryList = projectHistoryPagingData?.page < projectHistoryPagingData?.totalPage;

  return (
    <Styled.ProjectInfoHistory data-component-name="ProjectInfoHistory" $isClinic={isClinic}>
      <div className="projectInfoHistory__wrapper" ref={historyInfoRef}>
        <div className="projectInfoHistory__label" onClick={onClick}>
          <CustomText fontSize={14} fontColor="#444" fontWeight={400}>
            History
          </CustomText>
          <img src={isOpen ? fold_line_small_off : fold_line_small_on} />
        </div>
        <div
          className={cx('projectInfoHistory__contents', {
            isOpen,
          })}
        >
          <InfiniteScroll
            className="projectInfoHistory__contents_box infinite-scroll-box"
            dataLength={projectHistoryList?.length}
            next={onFetchHistoryList}
            hasMore={hasMoreHistoryList}
            loader={
              <div className="infinite-scroll-loading">
                <CircularLoading />
              </div>
            }
            height={408}
            scrollThreshold={0.95}
          >
            {!!isFetchSuccess &&
              projectHistoryList?.length > 0 &&
              projectHistoryList.map((item: any, index: number) => {
                return (
                  <div className="projectInfoHistory__item" key={index}>
                    <div className="projectInfoHistory__item_time">
                      <CustomText fontSize={13} fontColor="#666" fontWeight={400}>
                        {/* {moment(item.enrollDate).format('MMM. DD. YYYY HH:mm')}, {item?.nickname} */}
                        {moment(item.enrollDate)
                          .locale(language)
                          .format(language === 'en' ? 'MMM. DD. YYYY HH:mm' : 'YYYY. MM. DD HH:mm')}
                        , {item?.nickname}
                      </CustomText>
                    </div>
                    <div className="projectInfoHistory__item_content">
                      <CustomText fontSize={13} fontColor="#666" fontWeight={400}>
                        {t(`NOTIFICATION_EVENT_TYPE_${item?.type}`)}
                        {item?.type === 'CLIENT_REMAKE_REQ' && (
                          <>
                            {` l `}
                            Gap width of cement : {item?.params?.param1}, Minimal thickness :{' '}
                            {item?.params?.param2}, Adjust contact : {item?.params?.param3}, Adjust
                            bite : {item?.params?.param4}, Milling tool diameter :{' '}
                            {item?.params?.param5}
                            {item?.params?.param6 && `, Memo : ${item?.params?.param6}`}
                          </>
                        )}
                        {item?.type?.includes('FILE_') && ` l ${item?.params?.content}`}
                      </CustomText>
                    </div>
                  </div>
                );
              })}
          </InfiniteScroll>
        </div>
      </div>
    </Styled.ProjectInfoHistory>
  );
}

export default React.memo(ProjectInfoHistory);

const Styled = {
  ProjectInfoHistory: styled.div<{ $isClinic: boolean }>`
    position: relative;
    z-index: 999;
    .projectInfoHistory__wrapper {
      width: 100%;
      /* height: 30px; */
      /* background-color: olive; */
      position: relative;
      .projectInfoHistory__label {
        width: 100%;
        /* height: 30px; */
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: #fff;
        border: 1px solid #e1e1e7;
        border-radius: 3px;
      }
      .projectInfoHistory__contents {
        position: absolute;
        right: 0;
        bottom: ${({ $isClinic }) => ($isClinic ? `-408px` : `42px`)};
        /* bottom: 42px; */
        height: 408px;
        width: 100%;
        background-color: #fff;
        display: none;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.16);
        border-radius: 3px 3px 0px 0px;
        &.isOpen {
          display: block;
        }
        /* display: flex; */
        /* overflow: auto; */
        /* flex-direction: column; */
        /* height: 280px; */
        /* row-gap: 14px; */
        /* padding: 10px; */
        .projectInfoHistory__item {
          line-height: 18px;
          &:first-child {
            margin-top: 10px;
            margin-left: 10px;
          }
          &:last-child {
            margin-bottom: 10px;
            margin-left: 10px;
          }
          &:not(:first-child) {
            margin-top: 14px;
            margin-left: 10px;
          }
          .projectInfoHistory__item_time {
          }
          .projectInfoHistory__item_content {
          }
        }
      }
    }

    .MuiPaper-root {
      animation-direction: ${({ $isClinic }) => ($isClinic ? `normal` : `reverse`)};
      /* animation-direction: reverse; */
    }
  `,
};
